import { faqPageNode, jsonLdGraph } from '~/utils/schemaOrg';

export interface FaqSchemaEntry {
    question?: string;
    answer?: string;
}

export default function useFaqPageSchema(entries: MaybeRefOrGetter<FaqSchemaEntry[]>) {
    const route = useRoute();
    const canonicalUrl = useCanonicalUrl();
    const collected = useState<Record<string, string>>(`faq-schema-${route.path}`, () => ({}));

    watch(
        () => toValue(entries),
        value => {
            for (const entry of value ?? []) {
                if (!entry?.question || !entry?.answer) continue;
                collected.value[entry.question] = entry.answer;
            }
        },
        { immediate: true },
    );

    useHead(
        computed(() => {
            const questions = Object.entries(collected.value).map(([question, answer]) => ({ question, answer }));
            const node = faqPageNode({ canonicalUrl, questions });
            if (!node) return {};

            return {
                script: [
                    {
                        key: 'schema-org-faq',
                        type: 'application/ld+json',
                        innerHTML: jsonLdGraph([node]),
                    },
                ],
            };
        }),
    );
}
